import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { Navigate, useParams } from 'react-router-dom';

/**
 * `/requests` — kept only as a redirect.
 *
 * My requests moved under Create (/create/request), beside the forms that make
 * the requests, so "I asked for something" has one home rather than three. This
 * keeps old links and bookmarks working.
 */
export const requestsPage = PageBlueprint.make({
  name: 'requests',
  params: {
    path: '/requests',
    loader: async () => <Navigate to="/create/request" replace />,
  },
});

/**
 * `/create/tasks/:taskId` — the stock Tasks tab's URL for a template run, kept
 * as a redirect to where runs live now (/create/request/task/:taskId). With
 * that tab disabled (D-34) the path otherwise matched nothing under Create and
 * rendered an empty shell. A page of its own because a Create sub-page would
 * bring a tab back with it; the more specific route wins over /create.
 */
const OldTaskUrl = () => {
  const { '*': rest = '' } = useParams();
  return (
    <Navigate
      to={rest ? `/create/request/task/${rest}` : '/create/request'}
      replace
    />
  );
};

export const oldTasksPage = PageBlueprint.make({
  name: 'old-tasks',
  params: {
    path: '/create/tasks',
    loader: async () => <OldTaskUrl />,
  },
});
